import zhHKLocal from 'vant/lib/locale/lang/zh-HK'
import zhHKJame from './languageJame/zh-HK'
import zhHKGaea from './languageGaea/zh-HK'

const zhHK = {
  300000: '新年送禮',
  300001: '2022新年送禮',
  300002: 'SuperEx和你一起過新年',
  300003: '尊敬的SuperEx用戶：<br>為慶祝SuperEx在新年之際盛大上線,<br>平台將隨機空投送出價值1,000,000 USDT新年大禮包。<br>具體活動如下：',
  300004: '活動時間<br>加拿大時間：2022年01月01日00：00-02月15日23：59',
  300005: '活動一：分享海報獲空投',
  300006: '分享活動海報至＞1000人的telegram加密貨幣群組，並附言“百萬豪禮大派送，SuperEx和你一起過新年！或分享活動海報至個人Tiwwer，置頂並附言“百萬豪禮大派送，SuperEx和你一起過新年！”上傳截圖給客服，將有機會獲得5 ET（價值5 USDT）。',
  300007: '活動二：邀新獲VIP',
  300008: '獲得期間，用戶通過邀請好友新注冊並成功入金≥100 USDT即為有效邀請人數。成功邀請人數越多，所獲VIP等級越高。有效期（30天）',
  300009: '活動三：新用戶充值送',
  300010: '活動期間，新注冊用戶淨充值金額達到一下區間並完成一筆交易，即可獲得ET獎勵。（淨充值金額在活動結束前以USDT結算）活動期間，新注冊用戶淨充值金額達到一下區間並完成一筆交易，即可獲得ET獎勵。（淨充值金額在活動結束前以USDT結算）',
  300011: '注意事項：',
  300012: '1.每位參與用戶只能獲得一次獎勵 <br>2.所有參與用戶默認遵守SuperEx服務條款，如發現違規將立即停止其活動資格 <br>3.SuperEx有權在不提早通知用戶的情況下修改本次活動的條款 <br>4.SuperEx將取消不合規用戶活動參與資格並停用相關SuperEx賬戶使用 <br>5.SuperEx保留本次活動最終解釋權',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息關注SuperEx官網：SuperEx.com',
  300017: '淨充值金額（{coin}）',
  300018: '獎勵金（{coin}）',
  300019: '180天',
  300020: '淨充值=總入金金額-總出金金額',
  300021: 'ET持倉數量',
  300022: 'Maker/Taker',
  300023: '有效邀請人數',
  300024: '贈送有效期',
  300025: '活動獲取條件',
  300026: '注：所有贈送的VIP等級均無需ET持倉要求。',
  300027: '複製成功',
  300028: '複製失敗',

  300029: '下載 SuperEx APP',
  300030: '隨時隨地交易',
  300031: '創建SuperEx賬戶',
  300032: '若您已有SuperEx賬戶，請先登錄',
  300033: '郵箱',
  300034: '手機',
  300035: '手機號',
  300036: '密碼',
  300037: '推薦人ID(選填)',
  300038: '我已閱讀並同意',
  300039: 'SuperEx服務條款',
  300040: '我已滿18歲,並同意SuperEx服務條款',
  300041: '註冊',
  300042: '安全驗證',
  300043: '選擇區號',
  300044: '搜索',
  300045: '請輸入你的手機號',
  300046: '請輸入正確的手機號碼',
  300047: '請輸入你的郵箱地址',
  300048: '請輸入有效的電子郵件地址',
  300049: '請輸入你的密碼',
  300050: '至少8個字符，包含大寫字母和數字',
  300051: '郵箱驗證碼',
  300052: '短信驗證碼',
  300053: '谷歌/微軟驗證碼',
  300054: '谷歌/微軟驗證',
  300055: '為了您的賬戶安全,請完成以下驗證操作',
  300056: '提交',
  300057: '6位驗證碼將發送至您的手機{phone}',
  300058: '6位驗證碼將發送至您的郵箱{email}',
  300059: '請輸入6位SuperEx/谷歌/微軟驗證碼',
  300060: '請輸入6位驗證碼',
  300061: '發送驗證碼',
  300062: '{timeout}秒後重發',
  300063: '語言',
  300064: '審核中',
  300065: '請輸入英文字母或常用標點符號',

  300066: '任務中心',
  300067: '返傭排行大作戰',
  300068: '最高 <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em> 等你領！',
  300069: '去邀請',
  300070: '排行榜',
  300071: '解鎖規則',
  300072: '馬上行動領ET',
  300073: '返傭排行大作戰，最高1 BTC 等你領！',
  300074: '完成交易，解鎖 ET',
  300075: '完成以上所有任務可獲白名單，官方將不定期隨機向白名單用戶空投大量 ET。',
  300076: '活動日榜',
  300077: '活動累計榜',
  300078: '服務條款',
  300079: '我的獎勵',

  300080: '凍結數量',
  300081: '解鎖數量',
  300082: '解鎖數量=手續費*解鎖難度/ET價格',
  300083: '去交易',
  300084: '排名',
  300085: '賬號',
  300086: '傭金數量',
  300087: '注：當日排名計算至當日0:00，次日發放獎勵，數據可能存在誤差僅供參考。',
  300088: '注：活動結束後3個工作日內發放，數據可能存在誤差僅供參考。',
  300089: '查看更多',

  300090: '收起',
  300091: '您已是白名單用戶！',
  300092: '請輸入{type}賬號',
  300093: '填寫信息',
  300094: '立即關注twitter',
  300095: '立刻加入telegram',
  300096: '馬上進行第一筆充值',
  300097: '馬上進行第一筆現貨交易',
  300098: '馬上進行第一筆合約交易',
  300099: '立即推薦好友一起加入',

  300100: '協助好友進行交易',
  300101: '與好友一起領取更多',
  300102: '去充值',
  300103: '去關注',
  300104: '去領取',
  300105: '已領取（次）',
  300106: '暫未開放',
  300107: '加入社群',
  300108: '暫無數據',
  300109: '已完成',
  300110: '馬上行動領SCS，推薦好友得更多',
  300111: '取消',
  300112: '提交',
  300113: '請勿重複提交',
  300114: '當前沒有任務',
  300115: '更多任務敬請期待',
  300116: '更多活動敬請期待',
  300117: '綁定您的Twitter帳戶即可領取',
  300118: '綁定您的telegram帳戶即可領取',
  300119: '放弃',
  300120: '立即註冊 SuperEx',
  300121: '去註冊',
  300122: '已失效',
  300123: '白皮書',

  300124: '盲盒獎勵',
  300125: '領取1,000USDT數字盲盒獎勵， <em class="normal bold" style="color: #FFC72B">100%</em> 中獎',
  300126: '規則',

  300127: '開啟盲盒',
  300128: '抽獎次數',
  300129: '剩餘(我的)',
  300130: '已打開(總數USDT)',
  300131: '獎勵',
  300132: '玩法介紹',
  300133: '分享您的邀請鏈接',
  300134: '完成任務',
  300135: '邀請好友註冊，完成交易任務',
  300136: '領取盲盒',

  300137: '達成任務,獲取盲盒',
  300138: '本次活動已結束，敬請期待下一次活動！',
  300139: '本次活動暫未開始，敬請期待！',
  300140: '活動規則',
  300141: '好的',
  300142: '時間',
  300143: '',
  300144: '',
  300145: '邀請好友',
  300146: '點亮南瓜燈，玩轉<em class="normal" style="color: #FFC72B">万圣节</em>',
  300147: '連續簽到 <em class="normal" style="color: #FFC72B">{num}</em> 日，有機會贏取 <em class="normal" style="color: #FFC72B">{amount} ET</em> 大獎',
  300148: '中獎名單',
  300149: '每日簽到',

  300150: '您已累計簽到 {num} 天',
  300151: '抽大獎',
  300152: '已簽到',
  300153: '簽到',
  300154: '',
  300155: '',
  300156: '去補簽',
  300157: '獲得合約手續費抵扣券！',
  300158: 'VIP升級成功！',
  300159: '獲得抽獎機會！',

  300160: '合約手續費抵扣券',
  300161: 'VIP升級',
  300162: '',
  300163: '您有 <em class="normal" style="color: #FFC72B">{num}</em> 次補簽機會',
  300164: '獲得補簽機會',
  300165: '可補簽',
  300166: '提示',
  300167: '補簽成功',
  300168: '您還沒有補簽次數，當日淨充值≥{num} {symbol} 即可獲得1次補簽機會',
  300169: '登錄',

  300170: '補簽已達上限',
  300171: '連續簽到7天的用戶中獎名單',
  300172: '連續簽到可獲得以下獎勵',
  300173: '已領取',
  300174: '{num} 天',
  300175: '抵扣券',
  300176: 'VIP等級',
  300177: '參與抽獎',
  300178: '恭喜您',
  300179: '簽到成功',
  300180: '',
  300181: '學院',
  300182: '新聞',
  300183: '數據',
  300184: '學習',
  300185: '深入了解全球加密行業的重大事件',
  300186: '快速了解全球各地加密行業的最新事件',
  300187: '全面了解區塊鏈、Web3 和加密貨幣',
  300188: '閱讀更多',
  300189: '視頻',
  300190: '正在加載',
  300191: '已經全部加載完畢',
  300192: '全部',
  300193: '賽事暫未進行',
  300194: '預測比賽冠軍 贏取限定<em class="normal" style="color:#DBFF00">獎金</em>',
  300195: '活動時間',
  300196: '投票記錄',
  300197: '小組賽',
  300198: '{num}組',
  300199: '獎池: {num}',
  300200: '支持',
  300201: '淘汰賽',
  300202: '晉級',
  300203: '剩餘投票截止時間',
  300204: '投票',
  300205: '請輸入支持數量',
  300206: '最小競猜數量：{num} ET',
  300207: '競猜時間',
  300208: '競猜球隊',
  300209: '投入數量',
  300210: '中獎金額',
  300211: '出線球隊',
  300212: '天',
  300213: '時',
  300214: '分',
  300215: '秒',
  300216: '場次',
  300217: '活動暫未開始',
  300218: '1/4決賽',
  300219: '確定',
  300220: '支持數量',
  300221: '餘額不足',
  300222: '去充值',
  300223: '競猜成功',
  300224: '1/8決賽',
  300225: '半決賽',
  300226: '三、四名決賽',
  300227: '決賽',
  300228: '勝',
  300229: '敗',
  300230: '總獎池:{num} ET',
  300231: '查看更多場次',
  300232: '其他賽場',
  300233: '幣種',
  300234: '最新價格',
  300235: '24h漲跌幅',
  300236: '新手指導',
  300237: '即刻開啟數字貨幣交易學習',
  300238: '全球運營',
  300239: '無國界，社區去中心化自治，團隊去中心化是SuperEx發展的終極形態',

  300240: '安全零風險',
  300241: '集成去中心化SuperWallet，私鑰加密存儲在用戶設備端。不受代碼安全、政治等因素影響',
  300242: '無需註冊&KYC',
  300243: '錢包授權即交易，無需註冊，無需KYC，交易清算都在鏈上完成，無法篡改，安全透明',
  300244: '開放系統',
  300245: '開放用戶與Dapp或智能合約進行交互，進入SuperWallet可授權參與Meta、Defi 、Nft等各種場景',
  300246: '太空基金',
  300247: '太空基金用於人類探索太空或資助於對人類探索太空有重大貢獻的機構或個人',
  300248: '安全、易用的數字貨幣市場',
  300249: '下載SuperEx手機應用程序，隨時關注市場，在完美的時刻進行交易，無論你身在何處。',

  300250: '更多下載選擇',
  300251: '你的每一筆交易將助於我們推動人類對火星以及宇宙的探索！',
  300252: '立即註冊',
  300253: 'iOS & Android<br>掃碼下載',
  300254: '身份驗證器',
  300255: '驗證器會為您生成兩步驗證碼。 借助兩步驗證，讓您的SuperEx帳戶更加安全。',
  300256: 'SuperEx 驗證器',
  300257: '谷歌驗證器',
  300258: '微軟驗證器',
  300259: '下載用戶端(iPhone)',

  300260: '下載用戶端(Android)',
  300261: '全球最具信賴的數字資產交易平台',
  300262: '關於',
  300263: '服務協議',
  300264: '隱私條款',
  300265: '公告中心',
  300266: '學習',
  300267: '新手中心',
  300268: '現貨交易',
  300269: '合約交易',

  300270: '常見問題',
  300271: '服務',
  300272: '費率標準',
  300273: '交易規則',
  300274: '上幣申請',
  300275: '返傭',
  300276: '聯繫我們',
  300277: '幫助中心',
  300278: '提交工單',
  300279: '商務聯絡',

  300280: '機構合作',
  300281: '更多',
  300282: '歡迎回來',
  300283: '忘記密碼？',
  300284: '還沒有賬號？',
  300285: '請前往APP或者電腦上進行找回密碼的操作',
  300286: '我知道了',

  300287: '確認',
  300288: '待揭曉',
  300289: '待領取',

  300290: '已參與',
  300291: '已退款',
  300292: '購買規則',
  300293: "雲購 <span style='color: #ffc72b;'>好物</span>",
  300294: '購買參與',
  300295: '等待結果',
  300296: '領取商品',
  300297: '餘額充值',
  300298: '購買記錄',
  300299: '商品列表',
  300300: '單次參與費用',
  300301: '{num}份已售出，滿{price} {currency}結束搶購',
  300302: '立即搶購',
  300303: '繼續搶購',
  300304: '選擇購買份數',
  300305: "1份需<span style='color: #fa4d56;'>{minPrice} {currency}</span>，單個商品最多可購<span style='color: #fa4d56;'>{maxBuyCount} 份</span>",
  300306: '份',
  300307: '你有 {num} {currency}，購買份數越多获得的概率越大',
  300308: '購買',
  300309: '錯失良機',
  // 300309: '余额充值',
  300310: '恭喜您',
  300311: '去領取',
  300312: '再試一次',
  300313: '請在APP上執行充值或者P2P入金操作',
  // 300314: '我知道了',
  300315: '請在APP上聯繫客服來領取商品',
  // 300316: '我知道了',
  300317: '登錄/註冊',
  300318: '消耗 {num} {currency}',
  300319: '商品介紹',
  300320: '我的參與',
  300321: '時間',
  300322: '參與商品',
  300323: '購買份數',
  300324: '退款金額',
  300325: '操作',
  300326: '去領取',
  300327: '已有帳號？',
  300328: '去登錄',
  300329: '身份驗證碼',
  300330: '僅展示最近七天的記錄',
  300331:"身份驗證器",
  300332:'下載',
  300333:'1USDT可買1Bitcoin',
  300334:"搶購價",
  300335:"往期揭曉",
  300336:"期次",
  300337:"查看規則",
  300338:"期次:【第{num}期】",
  300339:"購買流程",
  300340:"搶購成功用戶",
  300341:"揭曉時間",
  300342:"分享",
  300343:"第【{num}】期",
  300345:"立刻下載",
  300346:"炫耀一下",
  300347:"掃碼參與",
  300348:"領取商品",
  300349:"提示:虛擬貨幣商品將在48小時內發到您的賬號;",
  300350:"其他商品請聯繫客服領取",
  300351:"去查看",
  300352:"立刻報名",
  300353:"已報名",
  300354:'報名已結束',
  300355:'報名成功',
  300356:'打開APP',
  300357: '恭喜{user}獲得{shop}！',
  300358: '活動中心',
  300359:'正在進行',
  300360:'即將開始',
  300361:'已經結束',
  300362:'立即參與',
  300363: '已經結束',
  300364: '獲獎者',
  300365: '獲獎名單即將揭曉',


  310000:'獎勵總覽',
  310001:'SCS 空投',
  300366: '貨幣',
  300367: '出售',
  200368: '支付',
  300369: '收到',
  300370: '獲得',
  300371: '單筆限額:',
  300372: '付款方式',
  300373: '收款方式',
  300374: '付款渠道',
  300375: '訂單詳情信息',
  300376: '金額（含交易費用）',
  300377: '到達時間',
  300378: '免責聲明',
  300379: '我已閱讀並同意免責聲明',
  300380: "您將離開SuperEx並跳轉到<span>{name}</span>，這是一家有執照的金融機構，作為第三方提供銀行卡支付能力。使用中發生任何風險事件均由<span>{name}</span>承擔。在使用<span>{name}</span>服務之前，請先閱讀並同意其<a class='pointer' href={server}>服務協議</a>如果您對信用卡押金有任何疑問，請聯繫 <a class='pointer' href={Customer}>{name}客服</a>以了解更多詳情。",
  300381: '如何在SuperEx上購買加密貨幣？',
  300382: '如何在SuperEx上出售加密貨幣？',
  300383: '下達加密貨幣訂單',
  300384: '選擇您想要支付的法定貨幣和您想要購買的加密貨幣。輸入您想要花費的金額。',
  300385: '驗證您的身份',
  300386: '在SuperEx和支付提供商上完成KYC驗證，完成支付。',
  300387: '檢查您的訂單詳細信息',
  300388: '檢查您的存款歷史記錄以查看訂單狀態。',
  300389: '常見問題',
  300390: '1. 我可以使用哪些支付方式購買加密貨幣？',
  300391: 'SuperEx目前支持VISA、Mastercard、Apple Pay、Google Pay等多種支付方式。支持的第三方服務提供商包括 Mercuryo、alchemypay。',
  300392: '2. 我可以購買哪些加密貨幣？',
  300393: 'SuperEx支持BTC、ETH、USDT、LTC、USDC、XRP、BCH、CRV、TRX等主流加密貨幣。',
  300394: '3. SuperEx是否監控支持的第三方服務提供商的質量和價格？',
  300395: 'SuperEx精心挑選了一批具有值得信賴的行業信譽、知名度、安全性的服務提供商，為用戶提供流程化的服務。',
  300396: '4. 購買加密貨幣需要支付哪些費用？',
  300397: '您向第三方服務提供商支付費用和鏈上轉賬費用。 SuperEx不收取任何費用。',
  300398: '5. 付款後需要多長時間才能收到加密貨幣？',
  300399: '當您在第三方服務商平台完成支付後，您的加密貨幣將在大約2-10分鐘內存入您的SuperEx現貨賬戶。',
  300400: '6. 購買過程中遇到問題怎麼辦？',
  300401: '如果您在交易過程中遇到任何問題，請聯繫客戶支持。如果您付款完成後仍未收到加密貨幣，請聯繫第三方服務提供商檢查 訂單詳細信息（這通常是最有效的方法）。由於您當前所在地區的IP或某些政策原因，您必須選擇人工驗證。',
  300402: "可用餘額",
  300403: '餘額不足',
  300404: '請輸入幣種',
  300405: '請輸入法幣',
  300406: '您尚未完成身份認證',
  300407: "為了您與您交易用戶的賬號安全，請先完成身份認證",
  300408: '去認證',
  300409: '暫不認證',
  300410: '選擇幣種',
  300411: '選擇法幣',
  300412: '全部幣種',
  300413: '全部法幣',
  300414: '約{time}分鐘',
  300415: 'P2P交易暫不對錢包授權用戶開放，請使用SuperEx賬號登錄後進行P2P交易',
  300416: 'https://support.superex.com/hc/zh-hk/articles/23083845808537',
  300417:'購買',
  300418: '序號',
  300419: 'SuperEx萬聖節嘉年華',
  300420: '簽到享好禮，交易贏獎金！',
  300421:'類型',
  300422:'幣種獎勵',
  300423:'',
  300424:'',

  400000:'全球首家基於Web3加密貨幣交易所',
  400001:'加入我們，共創自由的金融世界',
  400002:'你的每一筆交易將助於我們推動人類對火星以及宇宙的探索！',
  400003:'SuperEX精彩瞬間回顧',
  400004:'每一個精彩瞬間，都是我們足迹的見證和前行的力量',
  400005:'選擇語言和地區',
  400006:'0風險',
  400007:'無KYC',
  400008:'開放',
  400009:'基金',
  400010:'主網瀏覽器',
  400011:'測試網瀏覽器',
  400012:'開發者文檔',
  400013:'其他',
  400014:'ET 專區',
  400015:'',

  ...zhHKLocal,
  ...zhHKJame,
  ...zhHKGaea
}
export default zhHK;



// WEBPACK FOOTER //
// ./src/i18n/langs/zhHK.js